import { PlotStore } from "./store.js";
import { clonePlotFeature } from "./types.js";
export class CreatePlotCommand {
    label = "create-plot";
    #store;
    #feature;
    constructor(store, feature) {
        this.#store = store;
        this.#feature = clonePlotFeature({
            id: feature.id,
            plotType: feature.plotType,
            definitionVersion: feature.definitionVersion ?? "1.0.0",
            controlPoints: feature.controlPoints,
            parameters: feature.parameters ?? {},
            style: feature.style ?? {},
            metadata: feature.metadata ?? {},
            revision: feature.revision ?? 0,
        });
    }
    execute() {
        this.#store.add(this.#feature);
    }
    undo() {
        this.#store.remove(this.#feature.id);
    }
}
export class DeletePlotCommand {
    label = "delete-plot";
    #store;
    #id;
    #deleted;
    constructor(store, id) {
        this.#store = store;
        this.#id = id;
    }
    execute() {
        this.#deleted = this.#store.remove(this.#id);
    }
    undo() {
        if (!this.#deleted) {
            throw new Error("DeletePlotCommand cannot undo before execute.");
        }
        this.#store.add(this.#deleted);
    }
}
export class ReplacePlotCommand {
    label = "replace-plot";
    #store;
    #next;
    #previous;
    constructor(store, next) {
        this.#store = store;
        this.#next = clonePlotFeature(next);
    }
    execute() {
        this.#previous = this.#store.get(this.#next.id);
        this.#store.replace(this.#next);
    }
    undo() {
        if (!this.#previous) {
            throw new Error("ReplacePlotCommand cannot undo before execute.");
        }
        this.#store.replace(this.#previous);
    }
}
//# sourceMappingURL=commands.js.map